import "bootstrap/js/src/tab";
import AOS from "aos";

import "./topbar";
import "./cookie-consent";
import "../styles/index.scss";

AOS.init();
